<template>
  <div style="align-self: flex-end">
    <b-btn variant="default" class="mr-2" @click="previewFunction" v-show="showPreview">Preview</b-btn>
    <b-btn variant="default" class="mr-2" @click="close" v-show="showCancel">Cancelar</b-btn>
    <slot name="Sso"></slot>
    <b-btn
      variant="primary"
      @click="submit"
      v-show="showSubmit"
      :disabled="saveDisabled"
      >Salvar</b-btn
    >
  </div>
</template>

<script>
export default {
  props: {
    submit: Function,
    saveDisabled: Boolean,
    showSubmit: { default: true },
    showCancel: { default: true },
    previewFunction: Function,
    showPreview: { default: false }
  },
  methods: {
    close () {
      let th = this
      // this.$api.UI.Confirmacao('Deseja cancelar? ', function () {
      th.$emit('close')
      // })
    }
  }
}
</script>
